import { Event } from "../../Constants/objectTypes"
import {updateEvent,removeEvent} from "../../Endpoints"
import { ADD_CALENDAR_EVENT, REMOVE_CALENDAR_EVENT,SET_CALENDAR_EVENTS } from "../../Constants/reducerEvents"
const INITIAL_STATE:{events:Event[]} = {
    events:[]
}
export default function calendarReducer(state = INITIAL_STATE, action:{type:string,payload:any}) {
  switch (action.type) {
    case SET_CALENDAR_EVENTS:
      return {...state,events:action.payload}
    case ADD_CALENDAR_EVENT:
      updateEvent(action.payload)
      if(state.events.some(t=>t.id===action.payload.id)){
          console.log("Current state",state)
          return {...state,events:state.events.map(t=>{
            if(t.id===action.payload.id){
              return action.payload
            }
            return t
          })}
          
        }
        console.log("not")
        return {...state,events:[...state.events,action.payload]}
    case REMOVE_CALENDAR_EVENT:
      removeEvent(action.payload)
        return {...state,events:state.events.filter(t=>t.id!==action.payload)}
    default:
      return state
  }
}
